import React, { useEffect, useState } from "react";
import api from "../api";
import "../App.css";

const Templates = () => {
  const [list, setList] = useState([]);
  const [draft, setDraft] = useState({ title: "", content: "" });
  const [edit, setEdit] = useState(null);   // {id,title,content}
  const [notice, setNotice] = useState("");

  const load = () => api.post("/searchTemplate").then((r) => setList(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!draft.content.trim()) { setNotice("내용을 입력하세요."); return; }
    await api.post("/insert", draft);
    setDraft({ title: "", content: "" });
    setNotice("등록했습니다.");
    load();
  };

  const save = async () => {
    await api.post("/updateTemplate", edit);
    setEdit(null);
    setNotice("저장했습니다.");
    load();
  };

  const del = async (id) => {
    if (!window.confirm("이 템플릿을 지울까요?")) return;
    await api.post("/deleteTemplate", { data: [id] });
    setNotice("삭제했습니다.");
    load();
  };

  return (
    <div className="templates">
      <h2 className="title">템플릿</h2>

      <section className="card">
        <div className="card-head"><span>새 템플릿</span></div>
        <input
          className="input"
          placeholder="제목 (예: 이용료 고지서)"
          value={draft.title}
          onChange={(e) => setDraft({ ...draft, title: e.target.value })}
          maxLength={90}
        />
        <textarea
          className="msg"
          placeholder={"내용.  #{이름} 처럼 쓰면 엑셀 발송 때 사람마다 바뀝니다."}
          value={draft.content}
          onChange={(e) => setDraft({ ...draft, content: e.target.value })}
        />
        <div className="row end"><button className="btn primary" onClick={add}>등록</button></div>
      </section>

      {notice && <div className="notice">{notice}</div>}

      <div className="tpl-list">
        {list.map((t) => (
          <div className="card tpl" key={t.id}>
            {edit && edit.id === t.id ? (
              <>
                <input
                  className="input"
                  value={edit.title || ""}
                  onChange={(e) => setEdit({ ...edit, title: e.target.value })}
                  maxLength={90}
                />
                <textarea
                  className="msg"
                  value={edit.content}
                  onChange={(e) => setEdit({ ...edit, content: e.target.value })}
                />
                <div className="row end">
                  <button className="btn ghost sm" onClick={() => setEdit(null)}>취소</button>
                  <button className="btn primary sm" onClick={save}>저장</button>
                </div>
              </>
            ) : (
              <>
                <div className="card-head">
                  <span>{t.title || `템플릿 ${t.id}`}</span>
                  <span>
                    <button className="btn ghost sm" onClick={() => setEdit({ id: t.id, title: t.title || "", content: t.content })}>고치기</button>
                    <button className="btn ghost sm" onClick={() => del(t.id)}>삭제</button>
                  </span>
                </div>
                <pre className="tpl-body">{t.content}</pre>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Templates;
